export class BadRequestException implements Error {
  public name = 'Bad Request Exception'
  public message = 'HTTP Request failed with 400 bad request, check the parameters sent!'
}
